<mat-card *ngIf="status === 'PENDING'" class="enter-key">
    <h2>E-Mail-Adresse ändern</h2>
    <form (ngSubmit)="onSubmit()">
        <p>
            <mat-form-field color="accent">
                <input matInput type="text" name="email" id="email" [formControl]="emailFormControl"
                    autocomplete="false" placeholder="Neue E-Mail" required email />
                <mat-error *ngIf="emailFormControl.hasError('email')">
                    Geben Sie bitte eine gültige E-Mail-Adresse an.
                </mat-error>
                <mat-error *ngIf="emailFormControl.hasError('required')">
                    Bitte geben Sie E-Mail-adresse ein.
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <button mat-flat-button color="accent" type="submit" #submitKey id="submitKey">
                E-Mail speichern
            </button>
            <a class="lost-pw" routerLink="/willkommen">Zurück zur Übersicht</a>
        </p>
    </form>
</mat-card>